import { DEVICE_CATEGORY_ICONS } from './device-category-constants';

export function getCategoryIcon(category: string) {
  return DEVICE_CATEGORY_ICONS[category]?.icon || 'FalSquareQuestion';
}
